/**
 * <s-carousel> — native scroll-snap track with previous/next command buttons.
 *
 * Required markup:
 *   [data-carousel-track]   — the horizontally scrolling list inside this element.
 *   button[commandfor=<this id>][command="--prev" | "--next"] — arrow controls.
 */
class SCarousel extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const track = this.querySelector('[data-carousel-track]');
    if (!track) return;
    this.addEventListener('command', (event) => {
      const rtl = getComputedStyle(track).direction === 'rtl';
      const step = track.clientWidth * 0.85 * (rtl ? -1 : 1);
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (event.command === '--next') track.scrollBy({ left: step, behavior: smooth ? 'smooth' : 'auto' });
      if (event.command === '--prev') track.scrollBy({ left: -step, behavior: smooth ? 'smooth' : 'auto' });
    }, { signal: this.#ac.signal });
    track.addEventListener('scroll', () => this.#sync(track), { signal: this.#ac.signal, passive: true });
    this.#sync(track);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(track) {
    const max = track.scrollWidth - track.clientWidth;
    const pos = Math.abs(track.scrollLeft);
    for (const button of this.querySelectorAll('[command="--prev"]')) button.toggleAttribute('data-disabled', pos <= 2);
    for (const button of this.querySelectorAll('[command="--next"]')) button.toggleAttribute('data-disabled', pos >= max - 2);
  }
}

customElements.define('s-carousel', SCarousel);
